import React, { useEffect, useState } from "react";

const SplashScreen = ({ onFinish }) => {
  const [visible, setVisible] = useState(true);
  const [displayedCharacters, setDisplayedCharacters] = useState([]); 
  const fullText = "...."; 
  const TextLinksot = "Linksot";

  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      if (index < fullText.length) {
        setDisplayedCharacters((prev) => [...prev, fullText[index]]); 
        index++;
      } else {
        clearInterval(interval); 
        setTimeout(() => {
          setVisible(false);
          if (onFinish) onFinish(); 
        }, 500);
      }
    }, 60); 

    return () => clearInterval(interval); 
  }, [fullText, onFinish]);

  if (!visible) return null;

  return (
    <div style={styles.container}>
      <img src="/splashscreen.png" alt="Logo" style={styles.logo} />
      <h1>{TextLinksot}</h1>
      <h2 style={styles.title}>
        {displayedCharacters.map((char, i) => (
          <span key={i}>{char}</span> 
        ))}
      </h2>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#094d45",
    color: "#20a495",
  },
  logo: {
    width: "150px",
    height: "150px",
    marginBottom: "20px",
    animation: "fadeIn 1.5s",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    textAlign: "center",
    whiteSpace: "pre-wrap", 
  },
};

export default SplashScreen;
